import { render, staticRenderFns } from "./AlertVersion.vue?vue&type=template&id=3b929bc1&scoped=true&"
import script from "./AlertVersion.vue?vue&type=script&lang=js&"
export * from "./AlertVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b929bc1",
  null
  
)

export default component.exports